const [NAME, CODENAME, ACRONYM] = [0, 1, 2]
const aliasesById = {
  1: ['poker', 'poker2', 'poker'],
  12: ['empire', 'castle', 'em'],
  15: ['bigfarm', 'ranch', 'bf'],
  16: ['empirefourkingdoms', 'fourkingdoms', 'e4k'],
  23: ['legendsofhonor', undefined, 'loh'],
  41: ['empiremillenniumwars', undefined, 'emmw']
}

const idsByAlias = Object
  .entries(aliasesById)
  .reduce((result, [id, names]) => {
    id = parseInt(id, 10)
    result[id] = id

    names.forEach(name => {
      result[name] = id
    })
    return result
  }, {})

const id = alias => {
  alias = alias.toString().toLowerCase()
  const id = idsByAlias[alias]
  return id && (id | 0)
}

const aliasById = (aliasIndex, id) => {
  id = idsByAlias[id]
  return id && aliasesById[id][aliasIndex]
}

const name = aliasById.bind(null, NAME)
const codename = aliasById.bind(null, CODENAME)
const acronym = aliasById.bind(null, ACRONYM)

module.exports = {
  id,
  name,
  codename,
  acronym
}
